module.exports = __webpack_public_path__ + "img/ilerno-logo.b24de720.svg";